import { render, staticRenderFns } from "./BuyVip.vue?vue&type=template&id=77c070e8&"
import script from "./BuyVip.vue?vue&type=script&lang=js&"
export * from "./BuyVip.vue?vue&type=script&lang=js&"
import style0 from "./BuyVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports